export default __webpack_public_path__ + "assets/images/icon-shuffle.7bc657a3dab250b8d36e7a10fe131c27.svg";